<template>
  <span
    class="inline-block shrink-0 transform whitespace-nowrap transition-all duration-1000"
    :class="
      reducedSidebar
        ? 'w-0 grow-0 translate-x-96 overflow-hidden'
        : 'grow translate-x-0'
    "
    ><slot
  /></span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useUiStore } from '@/store/ui-store';

const uiStore = useUiStore();

const reducedSidebar = computed(() => uiStore.reducedSidebar);
</script>
